import { isOidcSession } from '@pequity/shared/utils/oidc';
import { useIdle } from '@vueuse/core';
import { watch } from 'vue';
import { pauseOidcRefresh, resumeOidcRefresh } from '@/utils/oidcTokenRefresh';
import { pauseSmCookieRefresh, resumeSmCookieRefresh } from '@/utils/smCookieRefresh';

const IDLE_THRESHOLD_MS = 2 * 60 * 1000;

export const useOidcIdleGuard = () => {
  const { idle } = useIdle(IDLE_THRESHOLD_MS);

  watch(idle, async (isIdle) => {
    if (!isOidcSession()) return;

    if (isIdle) {
      pauseOidcRefresh();
      pauseSmCookieRefresh();
    } else {
      const sessionAlive = await resumeSmCookieRefresh();
      if (sessionAlive) {
        resumeOidcRefresh();
      }
    }
  });
};
